export const wait = (time: number) => {
	return new Promise(resolve => {
		setTimeout(resolve, time);
	});
};

// ! Call with await wait(5000)
